import React, { useEffect } from 'react';
import Swal from 'sweetalert2';
import { app_links } from 'config';
import { useCookies } from 'react-cookie';

const CookiesPolicies = () => {

    const [cookies, setCookie] = useCookies(['aceptacookie']);

    const build_cookies = (_value = '', _expires = null) => {
        const _configure = { path: '/' };
        if(_expires){
            const current = new Date();
            const nextDate = new Date();
            switch(_expires){
                case 'year':
                    nextDate.setFullYear(current.getFullYear() + 1);
                    break;
                case 'day':
                    nextDate.setDate(current.getDate() + 1);
                    break;
            }
            _configure.expires = nextDate;
        }
        setCookie('aceptacookie', _value, _configure);
    }
    const configuracion_cookies = () => {
        Swal.fire({
            showCancelButton: !0,
            title: "Configuración de Cookies",
            text: "En Metro.pe nos preocupamos por mejorar la experiencia de compra, protegiendo tus datos personales. En consecuencia Metro.pe, usa dos tipos de cookies las funcionales y Analítica y Optimización.",
            confirmButtonText: "Sí Acepto todas",
            cancelButtonText: "Solo las funcionales",
            footer: `
            <div id="container-main">
                <div class="accordion-container">
                    <a href="javascript:void(0);" onClick="javascript:document.getElementById('acc1').className.includes('show-acc')?(this.classList.remove('open'),document.querySelector('.swal2-container').classList.remove('container-fit-1'),document.getElementById('acc1').classList.remove('show-acc')):(this.classList.add('open'),document.querySelector('.swal2-container').classList.add('container-fit-1'),document.getElementById('acc1').classList.add('show-acc'))" class="accordion-titulo">Funcionales<span class="toggle-icon"></span></a>
                    <div class="accordion-content" id="acc1">
                        <p>Son las que permiten la navegación óptima y el acceso a áreas seguras de la página web. La página web no podrá funcionar adecuadamente sin estas cookies. Con éstas también nos aseguramos que se cumpla la ley de protección de datos personales. Le informamos de que puede configurar su navegador para bloquear o alertar sobre estas cookies, sin embargo, es posible que determinadas áreas de la página web no funcionen. Estas cookies no almacenan ninguna información de identificación personal.</p>
                    </div>
                </div>
                <div class="accordion-container">
                    <a href="javascript:void(0);" onClick="javascript:document.getElementById('acc2').className.includes('show-acc')?(this.classList.remove('open'),document.querySelector('.swal2-container').classList.remove('container-fit-2'),document.getElementById('acc2').classList.remove('show-acc')):(this.classList.add('open'),document.querySelector('.swal2-container').classList.add('container-fit-2'),document.getElementById('acc2').classList.add('show-acc'))" class="accordion-titulo">Analíticas y optimización<span class="toggle-icon"></span></a>
                    <div class="accordion-content" id="acc2">
                        <p>Son aquellas que permiten al Editor de las mismas, el seguimiento y análisis del comportamiento de los usuarios de los sitios web a los que están vinculados. La información recogida mediante este tipo de cookies se utiliza en la medición de la actividad de los sitios web, aplicación o plataforma y para la elaboración de perfiles de navegación, con el fin de introducir mejoras en función del análisis de los datos de uso que hacen los usuarios del servicio.</p>
                    </div>
                </div>
            </div>`, 
            customClass: {
                container: 'cookies-config-container'
            }
        }).then(function(response){
            if(!response.value){
                build_cookies('funcionales', 'day');
                return;
            }
            build_cookies('yes', 'year');
        });
    }
    const politica_cookies = () => {
        Swal.fire({
            position: "bottom-left",
            title: "Política general sobre Cookies",
            text: "En Metro.pe nos preocupamos por mejorar tu experiencia de compra, sin descuidar la protección de tus datos personales. En consecuencia Metro.pe, usa dos tipos de cookies las Funcionales y las de Analítica y Optimización ¿consiente el uso de las cookies?",
            confirmButtonText: "Sí Acepto",
            showCancelButton: !0,
            cancelButtonText: "Configuración de Cookies",
            footer: `<div class="content-footer"><a href="${app_links.politicas_cookies}" target="_blank"><u>Política de Cookies</u></a></div>`,
            customClass: {
                container: 'cookies-policies-container'
            }
        }).then(function(response){
            if(!response.value){
                configuracion_cookies();
                return;
            }
            build_cookies('yes', 'year');
        });
    }

    useEffect(() => {
        if(cookies && !cookies.aceptacookie){
            politica_cookies();
        }
    }, []);

    return (
        <></>
    )
};

export default CookiesPolicies;
